import {CommonModule, Location} from '@angular/common'
import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core'
import {Router} from '@angular/router'
import {TranslateConfigService} from 'src/app/services/translate-config.service'
import {Clipboard} from '@capacitor/clipboard'
import {IonicModule, ToastController} from '@ionic/angular'
import {UtilsService} from 'src/app/services/utils/utils.service'
import {UserService} from "../../services/user/user.service";
import {Share} from '@capacitor/share';
import {TranslateModule} from '@ngx-translate/core';
import {DialogComponent} from '../dialog/dialog.component';

@Component({
  selector: 'app-details-header',
  templateUrl: './details-header.component.html',
  styleUrls: ['./details-header.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, DialogComponent]
})
export class DetailsHeaderComponent implements OnInit, AfterViewInit, OnChanges {
  constructor(
    private location: Location,
    private router: Router,
    private translateService: TranslateConfigService,
    private userService: UserService,
    private utilsService: UtilsService,
    private toastController: ToastController
  ) {
  }

  @Input() post: any
  @Input() mode: string = 'detail'
  @Input() isGuest: boolean = false
  @Input() isWeb: boolean = false
  @Output() showGuestModal: EventEmitter<any> = new EventEmitter

  show: boolean = false
  guest: boolean = false
  showShareDialog: boolean = false
  shareLink: string = '';
  showOptions: boolean = false
  optionsEvent: any = null

  goBack() {
    this.location.back()
  }

  navigate(path: string) {
    this.router.navigate([path])
  }

  ngOnInit() {
    this.updateShareLink();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['post'] && changes['post'].currentValue) {
      this.updateShareLink();
    }
  }

  ionViewDidEnter() {
    this.updateShareLink();
  }

  ngAfterViewInit(): void {
    this.updateShareLink();
  }

  private updateShareLink(): void {
    if (this.post && this.post.id) {
      this.shareLink = `https://foundek.com/details/${this.post.id}`;
    } else {
    }
  }

  openOptions(event: Event) {
    this.optionsEvent = event
    this.showOptions = true
  }

  report() {
    if (this.isGuest) {
      this.openModal()
    } else {
      this.navigate('/report-content')
    }
  }

  openModal() {
    this.show = !this.show
  }

  openShareDialog() {
    this.showShareDialog = true;
  }

  closeShareDialog() {
    this.showShareDialog = false;
  }

  async copyShareLink() {
    this.shareLink = `https://foundek.com/details/${this.post.id}`;
    try {
      await Clipboard.write({
        string: this.shareLink
      });
      this.presentToast(this.translateService.getItemTranslated('LINK_COPIED'));
      this.closeShareDialog();
    } catch (error) {
      this.presentToast(this.translateService.getItemTranslated('SHARE_FAILED'));
    }
  }

  /**
   * Comparte el post usando Capacitor Share; hace fallback a Web Share API o copiar enlace.
   */
  async sharePost() {
    try {
      if (!this.post) {
        return;
      }

      // Asegurar enlace actualizado
      this.updateShareLink();

      const title = this.post.title || 'Foundek';
      const text = this.post.description || 'Mira este anuncio en Foundek';
      const url = this.shareLink;

      // Intentar con Capacitor Share primero
      try {
        const canShare = await Share.canShare();
        if (canShare?.value) {
          await Share.share({
            title,
            text,
            url,
            dialogTitle: 'Compartir'
          });
          return;
        }
      } catch (e) {
        // Continuar con fallback
      }

      // Fallback: Web Share API si está disponible
      if (typeof navigator !== 'undefined' && (navigator as any).share) {
        try {
          await (navigator as any).share({title, text, url});
          return;
        } catch (e) {
          // Si el usuario cancela o falla, seguimos al siguiente fallback
        }
      }

      // Último fallback: mostrar diálogo de copia del enlace
      await Clipboard.write({string: url});
      this.presentToast(this.translateService.getItemTranslated('LINK_COPIED') || 'Link copied to clipboard');
    } catch (error) {
      this.presentToast(this.translateService.getItemTranslated('SHARE_FAILED') || 'No se pudo compartir');
    }
  }

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 2000,
      position: 'bottom'
    });
    toast.present();
  }

  confirm() {
    this.show = false
    setTimeout(async () => {
      if (this.isWeb) {
        this.router.navigate(['/login'])
      } else {

        const isWeb = await this.utilsService.detectIsWeb()

        this.router.navigate([!isWeb ? '/selection' : '/login'])
      }
    }, 200);
  }

  isOwner() {
    return this.post?.user?.id === this.userService.getUser()?.id;
  }
}
